<script>
	let {
		class: className = '',
		children,
		header = null,
		footer = null,
	} = $props();
</script>

<article
	class={[
		`
    relative flex flex-col overflow-hidden rounded-lg bg-indow-white
    text-indow-grey-dark shadow-md
  `,
		className,
	]}
>
	<header>{@render header?.()}</header>
	<div class="grow px-5 py-3">
		{@render children()}
	</div>
	<div>{@render footer?.()}</div>
</article>
